import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type CustomTitleClasses = 'indicative';

const customTitleStyles = makeStyles<ISpcTheme, CustomTitleClasses>(
  () => ({
    indicative: {
      cursor: 'pointer',
    },
  }),
  { name: 'Customise_CustomTitle' },
);

export default customTitleStyles;
